import { ToolCallInfo } from '~/components/AiChat/AiChatContext';
import type { ChatThreadMode } from '~/components/AiChat/AiChatContext';

import { json_headers, request } from './common';

export interface ChatRequestItem {
  role: 'user';
  content: string;
  kind: 'context' | 'user';
}

export interface ChatRequestContext {
  conversationRef: string | null;
  agentId: string | null;
  agentName?: string | null;
  agentEmail?: string | null;
  agentRoles?: Array<string>;
  customerId?: string | null;
  customerName?: string | null;
  orderId?: string | null;
  department?: string | null;
  mode?: ChatThreadMode;
  page?: string | null;
  hasPriorFraudDecision?: boolean;
}

export interface CreateConversationResponse {
  conversationId: string;
}

export interface SendConversationItemsRequest {
  conversationId: string;
  context: ChatRequestContext;
  items: Array<ChatRequestItem>;
  model?: string;
}

export interface ChatResponse {
  content: string;
  toolCalls: Array<ToolCallInfo>;
  responseId: string | null;
}

interface ResponsesApiOutput {
  type: string;
  role?: string;
  content?: Array<{ type: string; text: string }>;
}

interface ResponsesApiResult {
  id: string;
  output: Array<ResponsesApiOutput>;
  toolCalls?: Array<ToolCallInfo>;
}

export async function createConversation(): Promise<CreateConversationResponse> {
  const result = await request('/api/openai/conversations', {
    method: 'POST',
    headers: json_headers,
    body: JSON.stringify({}),
  });

  return {
    conversationId: result?.conversationId,
  };
}

export async function sendConversationItems(payload: SendConversationItemsRequest): Promise<ChatResponse> {
  const result: ResponsesApiResult = await request('/api/openai/responses', {
    method: 'POST',
    headers: json_headers,
    body: JSON.stringify(payload),
  });

  const messageOutput = result.output?.find((o) => o.type === 'message' && o.role === 'assistant');
  const textContent = messageOutput?.content?.find((c) => c.type === 'output_text');

  return {
    content: textContent?.text || 'No response received.',
    toolCalls: result.toolCalls || [],
    responseId: result.id || null,
  };
}

export async function transcribeAudio(audioBlob: Blob): Promise<string> {
  const formData = new FormData();
  formData.append('file', audioBlob, 'recording.webm');

  const result = await request('/api/openai/audio/transcriptions', {
    method: 'POST',
    body: formData,
  });

  return result?.text || '';
}
